export default "__VITE_ASSET__BYBFeKD9__"